module.exports = __webpack_public_path__ + "static/media/datagrams_thumb_home.005ec58f.jpg";